function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var getArrayBaseStyles = function getArrayBaseStyles(prefixCls, token) {
  var colorText = token.colorText,
    fontSizeLG = token.fontSizeLG,
    colorPrimaryText = token.colorPrimaryText,
    colorTextDisabled = token.colorTextDisabled;
  return [_defineProperty({}, ".".concat(prefixCls), {
    '&-remove, &-copy': {
      transition: 'all 0.25s ease-in-out',
      color: colorText + ' !important',
      fontSize: fontSizeLG,
      ':hover': {
        color: colorPrimaryText
      },
      '&-disabled': {
        color: colorTextDisabled,
        cursor: 'not-allowed !important',
        '&:hover': {
          color: colorTextDisabled
        }
      }
    },
    '&-sort-handle': {
      cursor: 'move',
      color: '#888 !important'
    },
    '&-addition': {
      transition: 'all 0.25s ease-in-out'
    },
    '&-move-down, &-move-up': {
      transition: 'all 0.25s ease-in-out',
      color: colorText,
      fontSize: fontSizeLG,
      marginInlineStart: 6,
      ':hover': {
        color: colorPrimaryText
      },
      '&-disabled': {
        color: colorTextDisabled,
        cursor: 'not-allowed !important',
        '&:hover': {
          color: colorTextDisabled
        }
      }
    }
  })];
};
export default getArrayBaseStyles;